import ApplicationController from '../application_controller.js'
import axios from 'axios'
import { isBlank } from '../../commons.js'
import State from './state.js'

export default class IfileTasksController extends ApplicationController {

  edit(e) {
    e.preventDefault()
    if (!State.editor_opened) {
      axios.get(e.target.getAttribute('href')).then(response => {
        this.element.closest('tr').outerHTML = response.data
        State.editor_opened = true
      })
    }
  }

  submit(e) {
    e.preventDefault()
    const form = e.target.closest('form')
    axios({
      method: form.getAttribute('method'),
      url: form.getAttribute('action'),
      data: new FormData(form)
    }).then(response => {
      this.element.outerHTML = response.data
      State.editor_opened = false
    }).catch(error => {
      this.alert(error.response.data)
    })
  }

  cancel(e) {
    e.preventDefault()
    if (isBlank(this.element.dataset.id)) {
      const tbody = document.querySelector("#filtered_table tbody");
      tbody.deleteRow(0);
    } else {
      axios.get(e.target.getAttribute('href')).then(response => {
        this.element.outerHTML = response.data
      })
    }
    State.editor_opened = false
  }

  destroy(e) {
    e.preventDefault()
    this.confirm(e.target.dataset.confirmText, reason => {
      if (reason.confirm) {
        axios.delete(e.target.getAttribute('href')).then(() => {
          this.element.remove()
        })
      }
      reason.close_modal()
    })
  }

}
